import { APP_TO_BUILD } from "../../appsConfig";
import { getAppTheme } from "./appThemeConfig";

export const appTheme = getAppTheme(APP_TO_BUILD);

export function applyAppTheme(element: HTMLElement) {
  element.style.setProperty("--primary", appTheme.primaryHsl);
  element.style.setProperty("--dp-brand", appTheme.brand);
  element.style.setProperty("--dp-brand-button", appTheme.brandButton);
  element.style.setProperty("--dp-brand-deep", appTheme.brandDeep);
  element.style.setProperty("--dp-brand-hover", appTheme.brandHover);
  element.style.setProperty("--dp-brand-soft", appTheme.brandSoft);
  element.style.setProperty("--dp-paywall-background", appTheme.paywallBackground);
}
